import { IconSymbol, ValidIconSymbolName } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';

import { getChipDisplayLabel } from '../../../../common/ChipsCategory/utils';
import { useLagoon } from '../../../../hooks/useLagoon';
import { ButtonStyled } from './CareTeamView.styled';

export const Chips = ({
  isSelected,
  text,
  selectedWrapperStyle,
  unselectedWrapperStyle,
  commonWrapperStyle,
  count,
  selectIcon,
  onPress,
  disabled = false,
}: {
  isSelected?: boolean;
  text: string;
  selectedWrapperStyle?: any;
  unselectedWrapperStyle?: any;
  commonWrapperStyle?: any;
  count?: number;
  selectIcon?: ValidIconSymbolName | undefined;
  onPress?: () => void;
  disabled?: boolean;
}) => {
  const uiMessaging = useLagoon('ui-messaging')();
  const displayText = getChipDisplayLabel({ label: text }, uiMessaging);

  return (
    <ButtonStyled
      cssProps={{
        isSelected,
        selectedWrapperStyle,
        unselectedWrapperStyle,
        commonWrapperStyle,
      }}
      data-auto-testid={`${text}-chip`}
      data-testid={`${text}-chip`}
      isDisabled={disabled}
      onClick={onPress}
      size="$md"
      variant="outline"
    >
      <Layout.Group>
        {isSelected && (
          <IconSymbol
            color="$darkBlue"
            data-auto-testid={'check-icon'}
            data-testid={'check-icon'}
            icon={selectIcon ?? 'check'}
            size={16}
            variant="outlined"
          />
        )}
        <Text
          color={disabled ? '#929496' : isSelected ? '$darkBlue' : '$blue'}
          data-auto-testid={`chip-${text}`}
          data-testid={`chip-${text}`}
          fontSize="sm"
          fontWeight="medium"
        >
          {displayText}
          {` (${count})`}
        </Text>
      </Layout.Group>
    </ButtonStyled>
  );
};
